import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-warning-box',
  templateUrl: './warning-box.component.html',
  styleUrls: ['./warning-box.component.css']
})
export class WarningBoxComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
